
import {  Options,mixins } from "vue-class-component";
import Toaster from "../helpers/Toaster";
import PaymentService from "../service/PaymentService";
import UtilityOptions from "../mixins/UtilityOptions";
import ToggleButton from 'primevue/togglebutton'               

interface IPaymentMethod {
  bankId: number;
  branchId: number;
  cardCharges: number;
  cardName: string;
  chargeCustomer: string;
  id: string;
}

interface PaymentListType {
  paymentTypeID: number;
  paymentType: string;
  accountNo: string;
  terminalId: string;
  authCode: string;
  transId: string;
  transStatus: string;
  transType: string;
  transDate: string;
  transTime: string;
  transAmount: number;
  transTotalAmount: number;
  transRef: string;
  entryMode: string;
  hostResponse: string;
  giftCardRef: string;
  cardBalance: string;
  tendered: number;
  change: number;
  roundOff: number;
  bankID: number;
}

interface ButtonRefs {
  addCashButton?: HTMLButtonElement; // Use appropriate type for the button element
  doneButton?: HTMLButtonElement;
}

@Options({
  components: {
    ToggleButton
  },
  props: {
    receiptDetail: Object,
    isToggled: String,
  },
  watch: {
    receiptDetail(obj) {
      this.paymentDialog = obj.dialogStatus;
      this.closeConfirmation = obj.closeConfirmation;
      this.amountLeft = Number(this.totalBill);
      this.itemSource = obj.itemSource;
      this.restriction = obj.restriction;
      this.paymentOptionType = obj.paymentOptionType;
      this.payLater = this.checkPermission(obj.payLater, 'pay_later', 'Pay Later');
      this.cardPayment = this.checkPermission(obj.cardPayment, 'card_payment', 'Manual');
      this.chequePayment = this.checkPermission(obj.chequePayment, 'cheque_payment', 'Cheque');
      this.paySupplierCredit = this.checkPermission(obj.paySupplierCredit, 'supplier_credit', 'SupplierCredit');
      this.cashPayment = this.checkPermission(obj.cashPayment, 'cash_payment', 'Cash');
      this.partiallyPaid = obj.partiallyPaid;
      this.hideKeyPad = obj.hideKeyPad;
      ////console.log("Pay later test obj",obj);
      this.customerID = obj.customerID;
      this.customerName = obj.customerName;
      this.customerType = obj.customerType
      this.paymentAction.needlePoints = obj.needlePoints;
      this.latency = obj.latency;
      ////console.log("latency of payemt ss", this.latency);
      this.dialogTitle = obj.dialogTitle;
      this.receivedTxt = obj.receivedTxt ? obj.receivedTxt:'Received'
    },
    paymentDialog(isVisible: boolean) {
      if (isVisible) {
        document.addEventListener('keydown', this.handleKeyPress);
        this.isToggled = this.$props.isToggled || "E Receipt";
      }else{
        document.removeEventListener('keydown', this.handleKeyPress);
      }
    }
  },
  emits: ["closePaymentScreenEvent", "getProceededPaymentsEvent"],
})

export default class PaymentScreen extends mixins(UtilityOptions) {

  private methodList: IPaymentMethod [] = [];
  private accountNo = "";
  private cardType = {
    bankId: 0,
    branchId: 0,
    cardCharges: 0,
    cardName: '',
    chargeCustomer: '',
    id:0
  } 
  private cheque = {
    id:4,
    bankId: 0,
    branchId: 0,
    cardCharges: 0,
    cardName: '',
    chargeCustomer: '',
  }
  private supplierCredit = {
    id:5,
    bankId: 0,
    branchId: 0,
    cardCharges: 0,
    cardName: '',
    chargeCustomer: '',
  }
  private paymentService;
  private paymentDialog = false;
  private paymentConfirmDialog = false;
  private closeConfirmation = false;
  private paymentCancelDialog = false;
  private itemSource = "";
  private transStatus = "000";
  private toast;
  private restriction = "";
  private paymentOptionType = ""
  private cashPayment = false;
  private partiallyPaid = false;
  private cardPayment=false;
  private chequePayment=false;
  private payLater=false;
  private paySupplierCredit=false;
  private screenNumber = "";
  private paymentMethodType = "";
  private amountLeft = 0;
  private roundedAmt = 0;
  private tipAmountTerminal = 0;
  private latency;
  private paymentAction = {
    tendered: 0,
    needlePoints: 0,
  };
  private accountNoCheque = "";
  private isToggled: string = ''; // Make value E Receipt to enable E Receipts else make value Pos Receipt
  private isDisabled: boolean = false; // Make false to activate E SMS
  private paymentList: PaymentListType[] = [];
  private hideKeyPad = false;
  created() {
    this.paymentService = new PaymentService();
    this.toast = new Toaster();
  }
  private currentCardTypeIndex = 0;

  private receivedTxt = 'Received';
  private allowedPaymentMethods = <any> [];

  /* currentFocusIndex: number = 0;
  focusableButtons: string[] = ['addCashButton', 'doneButton'];
 */
  mounted()
  {
    
      this.loadPaymentMethod();
      /* const numpadContainer = this.$refs.numpadContainer as HTMLElement;
      if (numpadContainer) {
        numpadContainer.addEventListener('keydown', this.handleKeyPress);
      } */
      //document.addEventListener('keydown', this.handleKeyPress);
      ////console.log(this.$refs);
      /* const initialButton = this.$refs[this.focusableButtons[this.currentFocusIndex]] as HTMLElement;
      //console.log(this.focusableButtons[this.currentFocusIndex]
      )
      if (initialButton) {
        initialButton.focus();
      } */
      /* const initialButton = this.$refs[this.focusableButtons[this.currentFocusIndex]] as Vue | HTMLElement;
      if (initialButton instanceof Vue && initialButton.$el instanceof HTMLElement) {
        initialButton.$el.focus();
      } else if (initialButton instanceof HTMLElement) {
        initialButton.focus();
      } */
      //const nextElementRef = this.focusableButtons[this.currentFocusIndex];
      /*const buttonElement = this.$refs[nextElementRef] as VueComponent & { $el: HTMLElement } | HTMLElement;

      if (buttonElement && '$el' in buttonElement) {
        (buttonElement.$el as HTMLElement).focus(); // If it's a Vue component, use $el
      } else if (buttonElement instanceof HTMLElement) {
        buttonElement.focus(); // If it's a direct HTML element
      } */
      //const buttonElement = this.$refs[nextElementRef] as Vue | HTMLElement;
      /* this.setFocus('addCashButton');
      this.setFocus(this.focusableButtons[this.currentFocusIndex]);
      //console.log('came to mount') */

   
      window.addEventListener('keydown', this.handleKeyDown);
      window.addEventListener('keypress', this.handleKeypress);
  }

  beforeUnmount() {
    // Remove event listener
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keypress', this.handleKeypress);
  }

  handleKeyDown(event) {
    if(this.paymentDialog){
      console.log('Key pressed:', event.key, 'KeyCode:', event.keyCode);
      // var focusedElem = document.activeElement;
      if (event.key == 'Enter') { // Key "*"
        event.preventDefault();
        if(this.paymentMethodType == 'Cash'){
          this.addCashAmount();
          // this.paymentMethodType = this.nextPayment(this.paymentMethodType, false);
        } else if(this.paymentMethodType == 'Cheque'){
          this.addChequeAmount();
          // this.paymentMethodType = this.nextPayment(this.paymentMethodType, false);
        } else if(this.paymentMethodType == 'Manual'){
          this.addManualAmount();
        }
        return '';
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.paymentMethodType = this.nextPayment(this.paymentMethodType, false);
        return '';
      } 
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.paymentMethodType = this.nextPayment(this.paymentMethodType, true);
        return '';
      }
      if (event.key === 'Delete') {
        event.preventDefault();
        var el = document.getElementById('delete-pay-item-' + (this.paymentList.length - 1));
        if (el){
          el.click();
        }
        return '';
      }
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if(this.paymentMethodType == 'Manual'){
          this.focusNext('accountNoInput', null, null);
        }
        if(this.paymentMethodType == 'Cheque'){
          this.focusNext('accountNoInputCheque', null, null);
        }
        return '';
      } 
    }
  }

  handleKeypress(event){
    if(this.paymentDialog){

      if (event.keyCode == 91) {
        this.nextPaymentMethod(true);
      }
      if (event.keyCode == 93) {
        this.nextPaymentMethod(false);
      }  

      if (event.keyCode == 42) { // Key "*"
        // if only has a one result, itll add that result to the items list
        // event.preventDefault();
        setTimeout(() => {   
          const el = document.getElementById('paymentDone');
          if (el){

            el.click();
          }
        }, 500);
      }
    }
  }
  
  nextPayment(previous, toBack = false){
    const previous_id = this.allowedPaymentMethods.find(item => item === previous);
    if(previous_id){
      var indexOfPrev = this.allowedPaymentMethods.indexOf(previous_id);

      if(toBack){
        return this.allowedPaymentMethods[indexOfPrev + 1] ? this.allowedPaymentMethods[indexOfPrev + 1]:this.allowedPaymentMethods[indexOfPrev];
      } else {
        return this.allowedPaymentMethods[indexOfPrev - 1] ? this.allowedPaymentMethods[indexOfPrev - 1]:this.allowedPaymentMethods[indexOfPrev];
      }
    }
    return this.allowedPaymentMethods[0];
  }

  nextPaymentMethod(up =false){
    if(this.cardType.cardName != ''){
      if(up){
        var defaultMethod = this.methodList[(this.currentCardTypeIndex  +1)];
        if(!defaultMethod){
          var defaultMethod = this.methodList[(this.currentCardTypeIndex )];
        }
      } else {
        var defaultMethod = this.methodList[(this.currentCardTypeIndex  -1 )];
        if(!defaultMethod){
          var defaultMethod = this.methodList[(this.currentCardTypeIndex )];
        }
      }
      Object.assign(this.cardType, defaultMethod);
    } else {
      var defaultMethod = this.methodList[0];
      Object.assign(this.cardType, defaultMethod);
    }
  }

  focusNext(refName, event, special) {

    var tempElement = document.getElementById(refName);
    if(special){
    }

    if(tempElement){
      tempElement.focus();
    }

  }
  

  /* setFocus(buttonRefName) {
    //console.log('came to focus')
    // Get the button element using its ref name
    //const buttonElement = this.$refs[buttonRefName];
    const buttonElement = this.$refs[buttonRefName] as HTMLButtonElement;
    //console.log(buttonElement)
   
    // Check if the button element exists and call its focus method if it does
    if (buttonElement) {
      buttonElement.focus(); // For PrimeVue Button, this should focus the button
    }
  } */

  /* setFocus(buttonRefName: string) {
    //console.log('came to focus')
    // Type the $refs using ButtonRefs interface
    const refs = this.$refs as unknown as ButtonRefs;
    const buttonElement = refs[buttonRefName];
    //console.log(buttonElement)
    if (buttonElement) {
      buttonElement.focus();
    }
  } */

  handleKeyPress(event: KeyboardEvent): void {
    const focusedElement = document.activeElement as HTMLElement;
    /////
    if(focusedElement.id !== 'accountNoInput' && focusedElement.id !== 'accountNoInputCheque' && !this.hideKeyPad){
      if (event.key === '1') {
        this.amountNumpad(1);
      }else if(event.key === '2'){
        this.amountNumpad(2);
      }else if (event.key === '3') {
        this.amountNumpad(3);
      }else if (event.key === '4') {
        this.amountNumpad(4);
      }else if (event.key === '5') {
        this.amountNumpad(5);
      }else if (event.key === '6') {
        this.amountNumpad(6);
      }else if (event.key === '7') {
        this.amountNumpad(7);
      }else if (event.key === '8') {
        this.amountNumpad(8);
      }else if (event.key === '9') {
        this.amountNumpad(9);
      }else if (event.key === '0') {
        this.amountNumpad(0);
      }else if (event.key === '.') {
        if (!this.screenNumber.includes('.') && this.screenNumber != '') {
            this.amountNumpad('.');
        }
      //}
      }else if (event.key === 'Delete') {
        this.amountNumpad('del');
      }else if (event.key === 'Backspace') {
        this.amountNumpad('backspace');
      }
      /* if (event.key === 'Enter') {
        //event.preventDefault();
        this.currentFocusIndex = (this.currentFocusIndex + 2

        ) % this.focusableButtons.length;
        const nextElementRef = this.focusableButtons[this.currentFocusIndex];

        const buttonElement = this.$refs[nextElementRef] as HTMLElement;
        if (buttonElement) {
          buttonElement.focus();
        } 
      
        const buttonElement = this.$refs[nextElementRef] as Vue | HTMLElement;

        if (buttonElement instanceof Vue && buttonElement.$el instanceof HTMLElement) {
        buttonElement.$el.focus();  // If it's a Vue component, use $el
        } else if (buttonElement instanceof HTMLElement) {
          buttonElement.focus();  // If it's a direct HTML element
        }
      }  */
    }
  }

  get progressBar() {
    return this.store.getters.getProgressBar;
  }

  get totalBill() {
    return this.store.getters.getTotalBill;
  }

  closePaymentScreen() {
    this.paymentList = [];
    this.$emit("closePaymentScreenEvent");
    this.paymentCancelDialog = false;
  }

  cancelPaymentConfirm() {
    this.paymentDialog = true;
    this.paymentCancelDialog = false;
  }

  confirmPaymentCancel() {
    if (this.totalPaymentsReceived > 0) {
      this.paymentCancelDialog = true;
    } else {
      this.paymentList = [];
      this.$emit("closePaymentScreenEvent");
      this.paymentDialog = false;
    }
  }

  private toggle() {
    if (this.isDisabled === false) {
      this.isToggled = this.isToggled === 'Pos Receipt' ? 'E Receipt' : 'Pos Receipt';
    } 
  }

  amountNumpad(num) {
    num = String(num);

    if (num == "del") {
      this.paymentAction.tendered = 0;
      this.screenNumber = "";
    } else if (num == "backspace") {
      if (this.screenNumber.endsWith('.')){
        this.screenNumber = this.screenNumber.toString().slice(0, -2);
        this.paymentAction.tendered = parseFloat(this.screenNumber) || 0;
      }else{
      this.screenNumber = this.screenNumber.slice(0, -1);
      this.paymentAction.tendered = parseFloat(this.screenNumber) || 0;
      }
    }else {
      if (this.paymentRounding > 0 || this.paymentMethodType == "Tip") {
        this.screenNumber = this.screenNumber + num;
        this.paymentAction.tendered = Number(this.screenNumber);
      } else {
        this.toast.showWarning("Invalid Amount must be greater than zero");
      }
    }
  }

  exactAmount() {
    this.paymentAction.tendered = this.paymentRounding;
  }

  fixLength(value) {
    const num = Number(value);
    value = num.toFixed(2);
    return value;
  }

  fixLengthNumber(value) {
    const num = Number(value);
    value = num.toFixed(2);
    value = Number(value);
    return value;
  }

  get totalPaymentsReceived() {
    let total = 0;

    this.paymentList.forEach((e) => {
      if (e.paymentType != "Tip") {
        total = total + e.transTotalAmount;
      }
    });

    return Number(total);
  }

  addCashAmount() {
    const tendered = Number(this.paymentAction.tendered);
    if (tendered == 0 && !this.partiallyPaid) {
      this.toast.showError("Please enter an amount greater than zero");
    } else {
      if (!this.checkCashPayment) {
        const receivableAmount = this.fixLengthNumber(
          tendered - this.changeAmount
        );
        this.paymentList.push({
          paymentTypeID:1,
          paymentType: "Cash",
          accountNo: "",
          transTotalAmount: receivableAmount,
          terminalId: "Manual",
          authCode: "",
          hostResponse: "",
          transId: "",
          transStatus: this.transStatus,
          transType: this.itemSource,
          transDate: "",
          transTime: "",
          transAmount: receivableAmount,
          transRef: "",
          entryMode: "",
          giftCardRef: "",
          cardBalance: "",
          tendered: this.fixLengthNumber(tendered),
          change: this.fixLengthNumber(this.changeAmount),
          roundOff: this.fixLengthNumber(this.roundedAmt),
          bankID: 0,
        });
      //  this.toast.showSuccess("Cash payment added successfully");

      } else {
        this.toast.showError("Cash type is already added");
      }
    }
  }

  addManualAmount() {
    if (this.accountNo.length != 4 || this.cardType == null) {
      this.toast.showError("Please choose Card Type and Card No must be 4 digits");
      return false;
    } else {
      const tendered = Number(this.paymentAction.tendered);
      if (tendered == 0) {
        this.toast.showError("Please enter amount greater than zero");
        return false;
      } else {
        const receivableAmount = this.fixLengthNumber(
          tendered - this.changeAmount
        );

        this.paymentList.push({
          paymentTypeID: this.cardType.id,
          paymentType: this.cardType.cardName,
          accountNo: this.accountNo,
          transTotalAmount: receivableAmount,
          terminalId: "Manual",
          authCode: "",
          hostResponse: "",
          transId: "",
          transStatus: this.transStatus,
          transType: this.itemSource,
          transDate: "",
          transTime: "",
          transAmount: receivableAmount,
          transRef: "",
          entryMode: "",
          giftCardRef: "",
          cardBalance: "",
          bankID: this.cardType.bankId,
          tendered: this.fixLengthNumber(tendered),
          change: this.fixLengthNumber(this.changeAmount),
          roundOff: 0,
        });
        this.toast.showSuccess(this.cardType.cardName + " Payment added successfully");
        this.accountNo = "";
        return true;
      }
    }
  }


  addChequeAmount() {
    if (this.accountNoCheque.length < 4 || this.cardType == null) {
      this.toast.showError("The 'Reference' must have at least 4 characters");
    } else if (this.accountNoCheque.length > 20 || this.cardType == null) {
      this.toast.showError("The 'Reference' should not exceed 20 digits");
    } else {
      const tendered = Number(this.paymentAction.tendered);
      if (tendered == 0) {
        this.toast.showError("Please enter amount greater than zero");
      } else {
        const receivableAmount = this.fixLengthNumber(
          tendered - this.changeAmount
        );

        this.paymentList.push({
          paymentTypeID: this.cheque.id,
          paymentType: 'Cheque',
          accountNo: this.accountNoCheque,
          transTotalAmount: receivableAmount,
          terminalId: "Cheque",
          authCode: "",
          hostResponse: "",
          transId: "",
          transStatus: this.transStatus,
          transType: this.itemSource,
          transDate: "",
          transTime: "",
          transAmount: receivableAmount,
          transRef: "",
          entryMode: "",
          giftCardRef: "",
          cardBalance: "",
          bankID: this.cheque.bankId,
          tendered: this.fixLengthNumber(tendered),
          change: this.fixLengthNumber(this.changeAmount),
          roundOff: 0,
        });
        this.toast.showSuccess("Cheque Payment added successfully");
        this.accountNoCheque = "";
      }
    }
  }

  addSupplierCreditAmount() {
      const tendered = Number(this.paymentAction.tendered);
      if (tendered == 0) {
        this.toast.showError("Please enter amount greater than zero");
      } else {
        const receivableAmount = this.fixLengthNumber(
          tendered - this.changeAmount
        );

        this.paymentList.push({
          paymentTypeID: this.supplierCredit.id,
          paymentType: 'SupplierCredit',
          accountNo: '',
          transTotalAmount: receivableAmount,
          terminalId: "SupplierCredit",
          authCode: "",
          hostResponse: "",
          transId: "",
          transStatus: this.transStatus,
          transType: this.itemSource,
          transDate: "",
          transTime: "",
          transAmount: receivableAmount,
          transRef: "",
          entryMode: "",
          giftCardRef: "",
          cardBalance: "",
          bankID: this.cheque.bankId,
          tendered: this.fixLengthNumber(tendered),
          change: this.fixLengthNumber(this.changeAmount),
          roundOff: 0,
        });
        this.toast.showSuccess("Payment added as a credit successfully");
        this.accountNo = "";
      }
  }

  get changeAmount() {
    let change = 0;
    const amountLeft = this.paymentRounding;
    const tendered = Number(this.paymentAction.tendered);
    const balance = tendered - amountLeft;

    if (balance > 0) {
      change = balance;
    }

    return change;
  }

  deletePayment(index, obj) {
    this.paymentList.splice(index, 1);
    this.toast.showSuccess(
      "Amount of " + this.currency + " " +
        this.fixLength(obj.transTotalAmount) +
        " removed successfully"
    );
  }


  clearAccountNo() {
    this.accountNo = "";
  }

  get checkCashPayment() {
    let status = false;
    this.paymentList.forEach((e) => {
      if (e.paymentType == "Cash") {
        status = true;
      }
    });

    return status;
  }


  get paymentRounding() {
    // //console.log("PAYMENT LIST function ");
    // //console.log("PAYMENT LIST ",this.paymentList);
    let amountLeftTemp = 0;
    let amountPaidTemp = 0;
    
    //REDUCING THE AMOUNT PAID
    this.paymentList.forEach((e) => {
      
      if (e.paymentType != "Tip") {
        amountPaidTemp = amountPaidTemp + e.transTotalAmount;
      }
    });

    if (this.paymentMethodType == "Cash") {
      const amountLeft = this.amountLeft - amountPaidTemp;
      //const roundNum = Math.round(amountLeft / 0.05) * 0.05;
      amountLeftTemp = Number(amountLeft);

      /* if (this.roundedAmt == 0) {
        this.roundedAmt = roundNum - amountLeft;
      } */
    } else if (this.paymentMethodType != "Tip") {
      amountLeftTemp = this.amountLeft - amountPaidTemp;
      this.roundedAmt = 0;
    } else {
      //nothing
    }


    this.paymentAction.tendered = amountLeftTemp;
    this.screenNumber = "";

    return amountLeftTemp;
    
  }

  confirmPayments() {
    //restriction == 'Yes'
    if (this.paymentRounding > 0.2 && this.restriction == "No") {
      this.paymentConfirmDialog = true;
    } else {
      this.emitPayments();
    }
  }

  enableDone(){
    return (this.restriction == 'Yes' && this.paymentRounding  > 0) ||
            (this.paymentMethodType != 'Pay Later' && this.totalPaymentsReceived <= 0) ||
            (this.paymentMethodType == 'Pay Later' && this.totalPaymentsReceived > 0);
  }

  emitPayments() {
    //this.$emit("getProceededPaymentsEvent", this.paymentList, this.isToggled);
    this.$emit("getProceededPaymentsEvent", this.paymentList, true);
    this.paymentDialog = false;
    this.paymentConfirmDialog = false;
    this.paymentList = [];
    this.clearPaymentScreen();
  }

  clearPaymentScreen() {
    this.amountLeft = 0;
    this.paymentAction.tendered = 0;
    this.paymentAction.needlePoints = 0;
  }

  loadPaymentMethod()
  {
    this.paymentService.paymentMethods().then((res) => {
      this.methodList = this.camelizeKeys(res.option);
      var defaultCard = this.methodList[0];
      if(defaultCard){
        Object.assign(this.cardType, defaultCard);
      }
      this.currentCardTypeIndex = 0;
    });
  }

  get currency() {
    return this.store.getters.getCurrency;
  }

  checkPermission(payment_enabled, payment_permission, payment_option){
    if(payment_enabled){
      if(this.can(payment_permission)){
        const hasValue = this.allowedPaymentMethods.find(item => item === payment_option);
        if(!hasValue){
          this.allowedPaymentMethods.push(payment_option);
        }
        this.paymentMethodType = payment_option;
        return true;
      }
    }
    return false;
  }

    //This part prevent unneccessary characters being entered in the qty input field
  validateUnit(event) {
    // Get the input value
    let inputValue = event.target.value;
    //console.log(event.target.value);
    // Allow digits and a single decimal point
    let numericValue = inputValue.replace(/[^0-9]/g, '');

    // Parse the value and ensure it's a valid number, allowing intermediate "." inputs
    var finalValue = isNaN(Number(numericValue)) ? numericValue + '' : Number(numericValue);
    
    if(finalValue == 0){
      this.accountNo = '';
    } else {
      finalValue = ''+finalValue;
      this.accountNo =  finalValue.slice(0, 4);
    }

    // to convert it to str
    finalValue = ''+finalValue;
    // Update the input field value directly, allowing user to see the current input
    event.target.value = finalValue.slice(0, 4);
  }

}
